import axios from 'axios'

export async function listWebhooks() {
    const { data } = await axios.get(`${process.env.API_URL}/webhooks`)
    return data
}

export async function getWebhookVersions() {
    const { data } = await axios.get(`${process.env.API_URL}/webhooks/versions`)
    return data
}

export async function getWebhook(id) {
    const { data } = await axios.get(`${process.env.API_URL}/webhooks/${id}`)
    return data
}

export async function createWebhook(body) {
    const { data } = await axios.post(`${process.env.API_URL}/webhooks`, body)
    return data
}

export async function updateWebhook(id, body) {
    await axios.patch(`${process.env.API_URL}/webhooks/${id}`, body)
}

export async function deleteWebhook(id) {
    await axios.delete(`${process.env.API_URL}/webhooks/${id}`)
}
